const map = {
    DateOfBirth: "#DateOfBirthGrid input[type=hidden].do-calendar",
};
export default map;
